import * as React from "react";
import { Card } from "react-bootstrap";
import { HelpButton as HelpButtonBase } from "lib/components/HelpButton";
import I18n from "lib/I18n";
import * as Routes from "lib/routes";
import { getStore } from "../../store";
import { observer } from "mobx-react-lite";

export const HelpButton = observer(() => {
  const app = getStore().app;
  const env = getStore().env.selected;
  const { lp1LoadInterval, titleUuid } = app;
  const queryPath = Routes.title_bigquery_query_form_path(titleUuid, env);
  const infoPath = Routes.title_bigquery_path(titleUuid, env);
  return (
    <HelpButtonBase>
      <Card className="mb-2">
        <Card.Header>このページは？</Card.Header>
        <Card.Body>
          <p>
            このページでは「定義の編集」で構成したキーの設定をBigQuery上のテーブルに反映することができます。
          </p>
          <ul>
            <li>
              BigQueryのテーブルは、dd1,
              lp1のような環境ごとに独立しています。メニューのドロップダウンから環境を選択して適宜テーブル定義を更新してください。
            </li>
            <li>
              テーブル定義の更新には時間がかかる場合があります。適宜再読み込みを実行してクエリの実行状態を確認してください。
            </li>
            <li>
              このイベントにどのようなキーが送信されているかについては、dd1環境の
              <a
                href={Routes.title_raw_posts_path(titleUuid)}
                target="_blank"
                rel="noreferrer"
              >
                {I18n.t("nav.raw_posts")}
              </a>
              で確認してください。
            </li>
            <li>
              JSONデータのdataエントリのキーの中からBigQueryのテーブルに取り込みたいものを
              「定義の編集」でキーとして追加し、保存してから、「テーブル定義の更新」を実行してください。
              すでにNX開発機からデータを送信済みである場合には、定義の自動生成を行うことができます。
            </li>
          </ul>
        </Card.Body>
      </Card>
      <Card className="mb-2">
        <Card.Header>BigQuery上のデータの確認方法</Card.Header>
        <Card.Body>
          3つの方法があります。
          <ul>
            <li>
              画面上部の「
              {I18n.t("event_master_editor.tab.table_status")}
              」メニューで、
              このイベント定義に対応するテーブルの最新1000件を確認することができます。
            </li>
            <li>
              <a href={queryPath} target="_blank" rel="noreferrer">
                BigQuery &gt; {I18n.t("nav.query")} ({env}環境)
              </a>
              で任意のSELECTクエリを実行しデータを確認することができます。
            </li>
            <li>
              BigQueryに接続してより複雑な分析を行いたい場合、
              <a href={infoPath} target="_blank" rel="noreferrer">
                BigQuery &gt; {I18n.t("nav.bigquery_connection_info")} ({env}
                環境)
              </a>
              で接続情報を確認することができます。
            </li>
          </ul>
        </Card.Body>
      </Card>
      <Card className="mb-2">
        <Card.Header>BigQueryへのデータの取り込みについて</Card.Header>
        <Card.Body>
          <ul>
            <li>
              対応するカラムがテーブルに定義されていないキーはBigQueryに読み込まれません。
            </li>
            <li>
              プレイヤーから送信されたJSONデータは、BigQuery上に取り込まれるまでに、
              dd1環境でおよそ24時間、 lp1環境でおよそ
              {lp1LoadInterval}
              時間、プレイレポートサーバーによってバッファされます。
            </li>
          </ul>
        </Card.Body>
      </Card>
    </HelpButtonBase>
  );
});
